import httpClient from "./httpClient";
import type { CryptoWalletSettings, AdminAuditLog } from "../types/api";

export const getCryptoWalletSettings = async (): Promise<CryptoWalletSettings> => {
  const response = await httpClient.get("/admin/settings/crypto-wallets");
  return response.data?.data ?? response.data ?? {};
};

export const updateCryptoWalletSettings = async (
  payload: CryptoWalletSettings
): Promise<CryptoWalletSettings> => {
  const response = await httpClient.put("/admin/settings/crypto-wallets", payload);
  return response.data?.data ?? response.data ?? {};
};

export const listCryptoWalletAuditLogs = async ({
  adminUserId,
  startDate,
  endDate,
}: {
  adminUserId?: number;
  startDate?: string;
  endDate?: string;
} = {}): Promise<AdminAuditLog[]> => {
  const params: Record<string, string | number> = {};
  if (adminUserId) params.adminUserId = adminUserId;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  const response = await httpClient.get("/admin/settings/crypto-wallets/audit", {
    params: Object.keys(params).length ? params : undefined,
  });
  return response.data?.data ?? response.data ?? [];
};
